<!--
 * @Descripttion: 地网承载页
 * @Author: chenjinsheng
 * @Date: 2021-10-14 09:30:57
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-10-19 14:01:30
-->
<template>
    <div class="fs-load-page-container">
        <img src="@/assets/pics/transition.png" alt="" />
        <div class="button" @click="openWin">进入地网无边</div>
    </div>
</template>

<script>
export default {
    mounted() {
        this.openWin();
    },
    methods: {
        openWin() {
            window.open(
                "http://api2.newhope.cn/auth/oauth/authorize?client_id=portal&response_type=code&redirect_uri=http%3A%2F%2Fudwwb.newhope.cn%2F%23%2Fwork-portal%2Findex"
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.fs-load-page-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100vh;
    img {
        width: 251px;
        height: 138px;
    }
    .button {
        width: 180px;
        height: 36px;
        line-height: 36px;
        border-radius: 4px;
        text-align: center;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        background: #2a6dff;
        margin-top: 40px;
        cursor: pointer;
    }
}
</style>
